import React, { useEffect, useState } from 'react'
import GenericTableComponent from '../../genericComponents/tableComponent/GenericTableComponent'
import GenericCustomButton from '../../genericComponents/GenericCustomButton'
import Icons from '../../assets/icons'
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { useSelector } from 'react-redux'
import ListComponent from '../../genericComponents/ListComponent'
import GenericSummarySkeleton from '../skeletons/GenericSummarySkeleton'
import { CONFIG } from '../../config';
import LanguageTranslator from '../../locals/LanguageTranslator'
import { getPermissionKey } from '../../helper/permissions'
import { formatNumber } from '../../helper/genericFunction'
import BreadCrumbs from '../../genericComponents/BraedCrumps'
import NoDataFound from '../../genericComponents/NoDataFound'

const SupportTickets = (props) => {
    const location = useLocation();
    const history = useHistory();

    const urlSearchParams = new URLSearchParams(location.search),
        params = Object.fromEntries(urlSearchParams.entries());
    const [currentTab, setCurrentTab] = useState(params.view ? JSON.parse(decodeURIComponent(params.view)) : "SELF");
    const generalStore = useSelector(state => state.generalStore);
    const [summaryData, setSummaryData] = useState({});
    const [summaryLoading, setSummaryLoading] = useState(true);

    const tableHeadersMap = {
        SELF: {
            main: {
                name: "Main",
                key: "SUPPORT_TICKET_DATA"
            },
        },
        ORG_INTERNAL: {
            main: {
                name: "Main",
                key: "SUPPORT_TICKET_DATA"
            },
        },
        ORG_EXTERNAL: {
            main: {
                name: "Main",
                key: "SUPPORT_TICKET_DATA"
            },
        }
        
    }

    useEffect(() => {
        if (generalStore?.["getTableComponentListData"]?.isSuccess) {
            setSummaryLoading(false);
            let data = generalStore?.["getTableComponentListData"]?.data;
            let obj = {
                "summaryData": data?.["summaryData"] || {},
                "priorityWiseData": data?.["priorityWiseData"] || {},
                "statusWiseData": data?.["statusWiseData"] || {},
                "dateWiseData": data?.["dateWiseData"] || {},
            }
            setSummaryData(obj || {});
        }
    }, [generalStore?.["getTableComponentListData"]?.isSuccess])

    // const renderRHSExtras = selectedItems => {
    //     return (

    //     )
    // }

    const isSmall = (str) => {
        return !(str && str.toString().length <= 45);
    }

    const changeTab = (tab) => () => {
        setCurrentTab(tab);
    }

    const renderTableSummary = () => {
        return summaryLoading ? <GenericSummarySkeleton /> :
            <div className="nph-history-search">
                <div className="nph-pi-po-quantity">
                    <ul className="nppq-inner">
                        <li className="nppq-history">
                            <LanguageTranslator tag="label">Total</LanguageTranslator>
                            <span>
                                <span className='group relative'>
                                    {summaryData?.["summaryData"]?.total_count || 0}
                                    {(formatNumber(summaryData?.["summaryData"]?.total_count)?.short !== 0 && formatNumber(summaryData?.["summaryData"]?.total_count)?.short) && <span className='generic-tooltip group-hover:opacity-100 group-hover:visible group-hover:pointer-events-auto'>{summaryData?.["summaryData"]?.total_count || ''}</span>}
                                </span>
                                <span className="nppqh-info">
                                    <Icons.SummaryInfoIcon />
                                    <div className="nppqhi-information !min-w-[250px]">
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th><LanguageTranslator tag="label">Status</LanguageTranslator></th>
                                                    <th><LanguageTranslator tag="label">Count</LanguageTranslator></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {summaryData?.statusWiseData?.length ? summaryData?.statusWiseData?.map((item, key) => (
                                                    <tr key={key}>
                                                        <td>
                                                            <LanguageTranslator tag="label" 
                                                                className={
                                                                    item.status === "Open" ? "nppqhii-status nppqhiis-can" :
                                                                        item.status === "Pending" ? "nppqhii-status nppqhiis-pen" :
                                                                            item.status === "Resolved" ? "nppqhii-status nppqhiis-apv" :
                                                                                item.status === "Closed" ? "nppqhii-status" :
                                                                                    "nppqhii-status nppqhiis-pen"
                                                                }
                                                            >{item.status}</LanguageTranslator>
                                                        </td>
                                                        <td align="right"><LanguageTranslator tag="label">{item.count}</LanguageTranslator></td>
                                                    </tr>
                                                )) : <tr className='h-full'><td align="center" colSpan={'100%'} className='h-full'><div className='h-[248px] min-h-[200px] flex flex-col items-center justify-center'>
                                                    <NoDataFound/>
                                                    {/* <LanguageTranslator tag="h3" className='mb-0 text-center text-lg font-semibold text-fontBlack'>No Data Found!</LanguageTranslator> */}
                                                </div></td></tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    {/* <div className="nppqhi-information">
                                        <ListComponent
                                            headerKeys={summaryData?.statusWiseData?.length && {
                                                "status": { value: "Status" },
                                                "count": { value: "Count" }
                                            }}
                                            itemKeys={{
                                                "status": [(states, functions, item) => <label
                                                    className={
                                                        item.status === "Open" ? "nppqhii-status nppqhiis-can" :
                                                            item.status === "Pending" ? "nppqhii-status nppqhiis-pen" :
                                                                item.status === "Resolved" ? "nppqhii-status nppqhiis-apv" :
                                                                    item.status === "Closed" ? "nppqhii-status" :
                                                                        "nppqhii-status nppqhiis-pen"
                                                    }
                                                >
                                                    {item.status}
                                                </label>],
                                                "count": ["count"]
                                            }}
                                            getListData={() => summaryData?.statusWiseData || []}
                                        />
                                    </div> */}
                                </span>
                            </span>
                        </li>
                        <li className="nppq-history nppqh-borderlft">
                            <LanguageTranslator tag="label">Open</LanguageTranslator>
                            <span>{summaryData?.["summaryData"]?.open_count || 0}
                                <span className="nppqh-info">
                                    <Icons.SummaryInfoIcon />
                                    <div className="nppqhi-information">
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th><LanguageTranslator tag="label">Date</LanguageTranslator></th>
                                                    <th><LanguageTranslator tag="label">Total</LanguageTranslator></th>
                                                    <th><LanguageTranslator tag="label">Open</LanguageTranslator></th>
                                                    <th><LanguageTranslator tag="label">Closed</LanguageTranslator></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {summaryData?.dateWiseData?.length ? summaryData?.dateWiseData?.map((item, key) => (
                                                    <tr key={key}>
                                                        <td>
                                                            <LanguageTranslator tag="label" >{item.created_at}</LanguageTranslator>
                                                        </td>
                                                        <td align="right"><LanguageTranslator tag="label">{item.total_count}</LanguageTranslator></td>
                                                        <td align="right"><LanguageTranslator tag="label">{item.open_count}</LanguageTranslator></td>
                                                        <td align="right"><LanguageTranslator tag="label">{item.closed_count}</LanguageTranslator></td>
                                                    </tr>
                                                )) : <tr className='h-full'><td align="center" colSpan={'100%'} className='h-full'><div className='h-[248px] min-h-[200px] flex flex-col items-center justify-center'>
                                                    <NoDataFound/>
                                                    {/* <LanguageTranslator tag="h3" className='mb-0 text-center text-lg font-semibold text-fontBlack'>No Data Found!</LanguageTranslator> */}
                                                </div></td></tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    {/* <div className="nppqhi-information">
                                        <ListComponent
                                            viewDataType="table-view"
                                            headerKeys={summaryData?.["priorityWiseData"]?.length && {
                                                "created_at": { value: "Date" },
                                                "total_count": { value: "Total" },
                                                "open_count": { value: "Open" },
                                                "closed_count": { value: "Closed" }
                                            }}
                                            itemKeys={{
                                                "created_at": ["created_at"],
                                                "total_count": ["total_count"],
                                                "open_count": ["open_count"],
                                                "closed_count": ["closed_count"]
                                            }}
                                            getListData={() => summaryData?.dateWiseData || []}
                                        />
                                    </div> */}
                                </span>
                            </span>
                        </li>
                        <li className="nppq-history nppqh-borderlft">
                            <LanguageTranslator tag="label">Closed</LanguageTranslator>
                            <span>{summaryData?.["summaryData"]?.closed_count || 0}</span>
                        </li>
                        <li className="nppq-history nppqh-borderlft">
                            <LanguageTranslator tag="label">Open (7 days avg)</LanguageTranslator>
                            <span>{summaryData?.["summaryData"]?.open_count_avg_per_day || 0}</span>
                        </li>
                        <li className="nppq-history nppqh-borderlft">
                            <LanguageTranslator tag="label">Closed (7 days avg)</LanguageTranslator>
                            <span>{summaryData?.["summaryData"]?.closed_count_avg_per_day || 0}
                                <span className="nppqh-info">
                                    <Icons.SummaryInfoIcon />
                                    <div className="nppqhi-information">
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th><LanguageTranslator tag="label">Priority</LanguageTranslator></th>
                                                    <th><LanguageTranslator tag="label">Total</LanguageTranslator></th>
                                                    <th><LanguageTranslator tag="label">Open</LanguageTranslator></th>
                                                    <th><LanguageTranslator tag="label">Closed</LanguageTranslator></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {summaryData?.["priorityWiseData"]?.length ? summaryData?.["priorityWiseData"]?.map((item, key) => (
                                                    <tr key={key}>
                                                        <td>
                                                            <LanguageTranslator 
                                                                tag="label" 
                                                                className={
                                                                    item.priority === "Low" ? "nppqhii-status nppqhiis-drft" :
                                                                        item.priority === "Medium" ? "nppqhii-status nppqhiis-apv" :
                                                                            item.priority === "High" ? "nppqhii-status nppqhiis-pen" :
                                                                                item.priority === "Urgent" ? "nppqhii-status nppqhiis-can" : ""
                                                                }
                                                            >
                                                                {item.priority}
                                                            </LanguageTranslator>
                                                        </td>
                                                        <td align="right"><LanguageTranslator tag="label">{item.total_count}</LanguageTranslator></td>
                                                        <td align="right"><LanguageTranslator tag="label">{item.open_count}</LanguageTranslator></td>
                                                        <td align="right"><LanguageTranslator tag="label">{item.closed_count}</LanguageTranslator></td>
                                                    </tr>
                                                )) : <tr className='h-full'><td align="center" colSpan={'100%'} className='h-full'><div className='h-[248px] min-h-[200px] flex flex-col items-center justify-center'>
                                                    <NoDataFound/>
                                                    {/* <LanguageTranslator tag="h3" className='mb-0 text-center text-lg font-semibold text-fontBlack'>No Data Found!</LanguageTranslator> */}
                                                </div></td></tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    {/* <div className="nppqhi-information">
                                        <ListComponent
                                            headerKeys={summaryData?.["priorityWiseData"]?.length && {
                                                "priority": { value: "Priority" },
                                                "total_count": { value: "Total" },
                                                "open_count": { value: "Open" },
                                                "closed_count": { value: "Closed" }
                                            }}
                                            itemKeys={{
                                                "priority": [(states, functions, item) => <label
                                                    className={
                                                        item.priority === "Low" ? "nppqhii-status nppqhiis-drft" :
                                                            item.priority === "Medium" ? "nppqhii-status nppqhiis-apv" :
                                                                item.priority === "High" ? "nppqhii-status nppqhiis-pen" :
                                                                    item.priority === "Urgent" ? "nppqhii-status nppqhiis-can" : ""
                                                    }
                                                >
                                                    {item.priority}
                                                </label>],
                                                "total_count": ["total_count"],
                                                "open_count": ["open_count"],
                                                "closed_count": ["closed_count"]
                                            }}
                                            getListData={() => summaryData?.["priorityWiseData"] || []}
                                        />
                                    </div> */}
                                </span>
                            </span>
                        </li>
                    </ul>
                </div>
            </div>
    }
    
    const renderBreadcrumbLHSExtras = () => {
        return [
                <GenericCustomButton
                    className={`mbcl-back-btn button-without-divider ml-1`}
                    onClick={()=>{
                        history.goBack();
                    }}
                    disabled={false}
                    loading={false}
                    leftIcon={<Icons.BackArrowIcon />}
                    label="Back"
                />
        ]
    }
    const renderBreadcrumbRHSExtras = () => {
        return [
                <a href="https://helpsupplymint.myfreshworks.com/login/auth/1629049404188?client_id=451980303908285122&amp;redirect_uri=https%3A%2F%2Fsupplymint.freshdesk.com%2Ffreshid%2Fcustomer_authorize_callback%3Fhd%3Dhelp.supplymint.com" target="_blank">
                    <button className="
                        generic-approve-btn
                        h-[32px] min-w-[100px]
                        focus:ring-2 focus:ring-primaryBtnFocus
                        flex items-center justify-center gap-[1px] rounded-[3px] text-xs font-medium
                        py-0.5 px-3
                    ">
                        Access Portal
                        <Icons.VendorRedirectIconWhite />
                    </button>
                </a>
        ]
    }

    return (
        <>
            <BreadCrumbs
                className='sticky'
                breadCrumbsProps={{
                    hideRoute: true,
                    lhsExtras: renderBreadcrumbLHSExtras,
                    rhsExtras: renderBreadcrumbRHSExtras
                }}
            />
            <GenericTableComponent
                braedCrumps={false}
                currentTab = {currentTab}
                actionBarConfig={{
                    emailReport: false,
                    downloadReport: {
                        headerLevelModule: tableHeadersMap?.[currentTab]?.main?.key,
                        tableHeadersMap: tableHeadersMap?.[currentTab]
                    },
                    tabs: {
                        key: "view",
                        data: props.type == "header" ? {
                            SELF: "Self",
                            ORG_INTERNAL: "Org Internal",
                            ORG_EXTERNAL: "Org External"
                        } : {
                            SELF: "Open",
                            ORG_INTERNAL: "Close",
                            ORG_EXTERNAL: "Portal Access"
                        },
                        onChange: changeTab
                    },
                    rhsExtras: (selectedItems) => <React.Fragment>
                        
                            <a href="https://helpsupplymint.myfreshworks.com/login/auth/1629049404188?client_id=451980303908285122&amp;redirect_uri=https%3A%2F%2Fsupplymint.freshdesk.com%2Ffreshid%2Fcustomer_authorize_callback%3Fhd%3Dhelp.supplymint.com" target="_blank">
                            <button className="
                                generic-approve-btn
                                h-[32px] min-w-[100px]
                                focus:ring-2 focus:ring-primaryBtnFocus
                                flex items-center justify-center gap-[1px] rounded-[3px] text-xs font-medium
                                py-0.5 px-3
                            ">
                                Access Portal
                                <Icons.VendorRedirectIconWhite />
                            </button>
                            </a>
                        {/* <GenericCustomButton
                            type="primary"
                            label="Access Portal"
                            rightIcon={<Icons.VendorRedirectIconWhite />}
                            href="https://helpsupplymint.myfreshworks.com/login/auth/1629049404188?client_id=451980303908285122&amp;redirect_uri=https%3A%2F%2Fsupplymint.freshdesk.com%2Ffreshid%2Fcustomer_authorize_callback%3Fhd%3Dhelp.supplymint.com"
                            target="_blank"
                        /> */}
                    </React.Fragment>
                }}
                tableConfig={{
                    customCols: {
                        ticketId: item => {
                            return <label>
                                <a data-interactive="true" style={{ display: "flex", flexDirection: "row" }} href={item.ticketUrl} target="_blank">
                                    {item["ticketId"]} <Icons.VendorRedirectIcon />
                                    {isSmall(item["ticketId"]) && <div className="table-tooltip"><label>{item["ticketId"]}</label></div>}
                                </a>
                            </label>
                        },
                    },
                    summary: {
                        render: renderTableSummary
                    }
                }}
                tableDataPayload={{
                    reportFilter: {},
                    pageNo: 1,
                    pageSize: 10,
                    sortedBy: "",
                    sortedIn: "",
                    search: "",
                    filter: {},
                    type: 1,
                    view: currentTab,
                    apiUrl: "/mdm/support/ticket/get/all",
                    baseUrl: CONFIG.SM_BACKEND_BASE_URL
                }}
                tableHeadersPayload={tableHeadersMap?.[currentTab]}
                tableComExtraHeaders={getPermissionKey("common", "commonfunctionality", "view")}
                tableHeadersMap={tableHeadersMap}
                    setCurrentTab = {setCurrentTab}
                tableData={
                    {
                        data: generalStore?.getTableComponentListData?.data?.resource || [],
                        totalItems: generalStore?.getTableComponentListData?.data?.totalRecord || 0,
                        currentPage: generalStore?.getTableComponentListData?.data?.currPage || 1,
                        maxPage: generalStore?.getTableComponentListData?.data?.maxPage || 1,
                        getTableApiData: generalStore?.getTableComponentListData?.data || []
                    }
                }
                availableStores={["generalStore"]}
                {...props}
            />
        </>
    )
}

export default SupportTickets